/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
//import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { uploadFileAction } from 'Admin/actions/link';
import { updateServingSizeAction } from 'Admin/actions/serving_size';
import { languageListAction } from 'Admin/actions/language';

let Validator = require('validatorjs');
let formArr = {}
let rules = {
    name_1: 'required',
    //ut_1: 'required',
    //utensil: 'required',
    //file: 'required',

};
let mess = {
    required: 'This field is required',
};
let validation = [];
validation = new Validator({}, rules, mess);
validation.passes();
validation.fails();

class UpdateServingSize extends Component {

    constructor(props) {
        super(props);
        this.state = {
            languageList: [],
            cardHidden: true,
            formArr: [],
            nameError: null,
            name_englishError: null,
            ut_englishError: null,
            fileError: null,
            formData: {
                name: this.props.location.state.row.name,
                utensil: this.props.location.state.row.utensil,
                file: this.props.location.state.row.image,
                id: this.props.location.state.row._id,
                name_1: this.props.location.state.row.name['1'],
                ut_1: this.props.location.state.row.utensil['1'],
            },
            isLogin: true,
            showProcessing: false,
            limitForm: {},
        }
    }

    componentDidMount() {
        let data = this.state.limitForm;
        data['limitStatus'] = true;
        this.props.languageListAction(data);

    }


    componentWillReceiveProps(nextProps) {

        if (nextProps.isUpdateServingSizeError !== this.props.isUpdateServingSizeError) {
            if (nextProps.msg.errors) {
                nextProps.msg.errors.map((key, i) => {
                    this.setState({ [(key.param) + "Error"]: <small className="text-danger">{key.msg}</small> })
                });
            }
        }

        if (nextProps.isUploadFile !== this.props.isUploadFile) {
            let uploaded_file = this.state.uploaded_file;
            let field = this.state.formData;
            field[uploaded_file] = nextProps.uploadFile.file_name;
            this.setState({ formData: field });
        }

        if (nextProps.isLanguageList !== this.props.isLanguageList) {
            this.setState({ languageList: nextProps.LanguageList.data });
        }

        if (nextProps.isUploadFileError !== this.props.isUploadFileError) {
            if (nextProps.uploadFile.errors) {
                let uploaded_file = this.state.uploaded_file;
                nextProps.uploadFile.errors.map((key, i) => {
                    this.setState({ [uploaded_file + "Error"]: key.msg })
                });
            }
        }

        if (nextProps.isUpdateServingSize !== this.props.isUpdateServingSize) {
            this.props.handleClick('success', nextProps.UpdateServingSize.msg)
            this.props.history.push('/admin/serving-size-list')
        }
    }



    handleChange(e, language) {
        e.preventDefault();
        let field = this.state.formData;
        field.name[language] = e.target.value;
        field[e.target.name] = e.target.value;
        this.setState({ formData: field });
    };

    handleChangeUtensil(e, language) {
        e.preventDefault();
        let field = this.state.formData;
        field.utensil[language] = e.target.value;
        field[e.target.name] = e.target.value;
        this.setState({ formData: field });
    };


    fileChangedHandler(event, elename) {
        event.preventDefault();
        this.setState({ uploaded_file: elename });
        let reader = new FileReader();
        let file = event.target.files[0];
        this.props.uploadFileAction(file);
        reader.readAsDataURL(file);
    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function (key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    updateServingSize(evt) {
        evt.preventDefault();
        const _this = this;
        if (this.allValidate(false)) {
            let field = this.state.formData;
            field.image = field.file;
            this.setState({ formData: field });
            _this.setState({ showProcessing: true });
            _this.props.updateServingSizeAction(field);
        }
        //validation.errors()
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    render() {


        validation = new Validator(this.state.formData, rules, mess);
        validation.passes();
        validation.fails();
        let _this = this;
        return (
            <div className="main-content" style={{ padding: '15px 0px' }}>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend className="line-removes">
                                    <Button className="go-back-btn-1" bsStyle="info" onClick={(e) => { this.goBackFun(e) }}>Back</Button>
                                </legend>}
                                content={
                                    <Form horizontal>


                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                QTY unit name <span className="star">*</span>
                                            </Col>
                                            <Col sm={6} className="spcc">
                                                {this.state.languageList.map(function (lang) {
                                                    return <><label>{lang.name}</label><FormControl className="spc-in" type="text" name={'name_' + lang.lanId} id={'name_' + lang.lanId} placeholder={lang.name} value={_this.state.formData.name[lang.lanId]} onChange={(event) => { _this.handleChange(event, lang.lanId) }} /></>
                                                })}
                                                <span className="errorMsg">
                                                    {this.state.name_englishError}
                                                    {this.state.formArr.name_1 && validation.errors.first('name_1')}</span>
                                            </Col>

                                        </FormGroup>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                Utensil name <span className="star"></span>
                                            </Col>
                                            <Col sm={6} className="spcc">

                                                {this.state.languageList.map(function (lang) {
                                                    return <><label>{lang.name}</label><FormControl className="spc-in" type="text" name={'ut_' + lang.lanId} id={'ut_' + lang.lanId} placeholder={lang.name} value={_this.state.formData.utensil[lang.lanId]} onChange={(event) => { _this.handleChangeUtensil(event, lang.lanId) }} /></>
                                                })}
                                                <span className="errorMsg">
                                                    {this.state.ut_1}
                                                    {this.state.formArr.ut_1 && validation.errors.first('ut_1')}</span>
                                            </Col>

                                        </FormGroup>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                File
                                            </Col>
                                            <Col sm={6}>
                                                <input type="hidden" name="id" value={this.state.formData.id} onChange={e => { this.fileChangedHandler(e, "id") }}></input>
                                                <input type="file" name="file" onChange={e => { this.fileChangedHandler(e, "file") }}></input>{this.state.formData.file}
                                            </Col>
                                        </FormGroup>


                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}></Col>
                                            <Col sm={6}>
                                                <button type="button" onClick={this.updateServingSize.bind(this)} className="btn-fill btn-wd btn btn-info">Save</button>&nbsp;
                                            </Col>
                                        </FormGroup>

                                    </Form>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        msg: state.servingSize.message,

        UpdateServingSize: state.servingSize.UpdateServingSize,
        isUpdateServingSize: state.servingSize.isUpdateServingSize,
        isUpdateServingSizeError: state.servingSize.isUpdateServingSizeError,

        isUploadFile: state.link.isUploadFile,
        isUploadFileError: state.link.isUploadFileError,
        uploadFile: state.link.uploadFile,

        LanguageList: state.language.LanguageList,
        isLanguageList: state.language.isLanguageList,
        isLanguageListError: state.language.isLanguageListError,
    }
}
export default withRouter(connect(mapStateToProps, { updateServingSizeAction, uploadFileAction, languageListAction })(UpdateServingSize));
